import { styled } from "@mui/system"
import ConventionSession from "models/convention-api/v1/ConventionSession"
import React from "react"

interface SessionTagsProps {
  className?: string
  session: ConventionSession
}

const SessionTags = (props: SessionTagsProps) => {
  const { session, className } = props

  return (
    <_TagList className={className}>
      {session.taggings?.map(({ tag }) => {
        if (!tag) return null
        return <_TagListItem key={tag.id}>{tag.name}</_TagListItem>
      })}
    </_TagList>
  )
}

export default SessionTags

const _TagList = styled("ul")({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  alignContent: "flex-start",
  flexFlow: "row wrap",
  gap: "20px",
  listStyleType: "none",
  margin: 0,
  padding: 0,
})

const _TagListItem = styled("li")(({ theme }) => ({
  padding: "8px 10px",
  background: theme.palette.gray.dark,
  borderRadius: "10px",

  ...theme.fonts.lato400,

  fontSize: "16px",
  lineHeight: "22px",

  color: theme.palette.gray.lightest,
}))
